import {BaseContainerModel} from '../base-container.model';
import {bl_applet_client_side_perm_to_group_link_RowClass} from '../../dbschema';

export class ClientSidePermissionTeamLinkContainer extends BaseContainerModel {
    bl_applet_client_side_perm_to_group_link: bl_applet_client_side_perm_to_group_link_RowClass = new bl_applet_client_side_perm_to_group_link_RowClass();
}
